import type { Dispatch } from '@atlaskit/editor-common/event-dispatcher';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { RemixModalMetadata } from '../types';

export type MalleableUiPluginState = {
	isRemixModalOpen: boolean;
	remixModalMetadata?: RemixModalMetadata;
};

export type MalleableUiPluginMeta = {
	isRemixModalOpen?: boolean;
	remixModalMetadata?: RemixModalMetadata;
};

export const malleableUiPluginKey: PluginKey<MalleableUiPluginState> =
	new PluginKey<MalleableUiPluginState>('malleableUiPlugin');

export function createMalleableUiPmPlugin(dispatch: Dispatch): SafePlugin {
	return new SafePlugin({
		key: malleableUiPluginKey,
		state: {
			init(): MalleableUiPluginState {
				return {
					isRemixModalOpen: false,
					remixModalMetadata: undefined,
				};
			},
			apply(tr, pluginState): MalleableUiPluginState {
				const meta: MalleableUiPluginMeta | undefined = tr.getMeta(malleableUiPluginKey);

				if (meta && meta.isRemixModalOpen !== undefined) {
					const result: MalleableUiPluginState = {
						isRemixModalOpen: meta.isRemixModalOpen,
						remixModalMetadata: meta.remixModalMetadata,
					};
					dispatch(malleableUiPluginKey, result);
					return result;
				}

				return pluginState;
			},
		},
	});
}
